export var SocketEventTypes;
(function (SocketEventTypes) {
    SocketEventTypes["SocketConnected"] = "LD:SOCKET:CONNECTED";
    SocketEventTypes["UserChange"] = "user:change";
    SocketEventTypes["PopRecord"] = "pop:record";
    SocketEventTypes["IncomingCall"] = "incoming:call";
    SocketEventTypes["IncomingCallCancelled"] = "incoming:call:cancelled";
    SocketEventTypes["ConferenceJoin"] = "conference:join";
    SocketEventTypes["ConferenceLeave"] = "conference:leave";
})(SocketEventTypes || (SocketEventTypes = {}));
